/**
 * Display helpers for collaboration invite/application row statuses.
 * Finished repeat-collaboration sources are stored as `completed` (legacy: `closed`).
 */

export function isCompletedSourceStatus(status) {
  const normalized = String(status || '').toLowerCase();
  return normalized === 'completed' || normalized === 'closed';
}

export function isPendingCollaborationStatus(status, kind) {
  const normalized = String(status || '').toLowerCase();
  if (kind === 'application') {
    return normalized === 'pending' || normalized === 'submitted';
  }
  return normalized === 'pending';
}

/** 0 = pending first, 1 = other open rows, 2 = completed last. */
export function getCollaborationListRank({ pending = false, completed = false } = {}) {
  if (pending) return 0;
  if (completed) return 2;
  return 1;
}

export function getCollaborationDisplayStatus(itemStatus, acceptanceStatus) {
  const item = String(itemStatus || '').toLowerCase();
  const acceptance = String(acceptanceStatus || '').toLowerCase();

  if (acceptance === 'cancelled' || acceptance === 'canceled'
    || item === 'cancelled' || item === 'canceled') {
    return 'cancelled';
  }
  if (acceptance === 'completed' || isCompletedSourceStatus(item)) {
    return 'completed';
  }
  if (item === 'rejected' || item === 'declined') {
    return 'rejected';
  }
  return item || 'pending';
}

export function getCollaborationStatusLabel(displayStatus) {
  switch (String(displayStatus || '').toLowerCase()) {
    case 'completed':
      return 'Completed';
    case 'cancelled':
    case 'canceled':
      return 'Canceled';
    case 'rejected':
    case 'declined':
      return 'Declined';
    case 'approved':
      return 'Approved';
    case 'accepted':
      return 'Accepted';
    case 'negotiating':
      return 'Negotiating';
    case 'submitted':
      return 'Submitted';
    case 'expired':
      return 'Expired';
    case 'closed':
      return 'Completed';
    case 'pending':
    default:
      return displayStatus
        ? `${String(displayStatus).charAt(0).toUpperCase()}${String(displayStatus).slice(1)}`
        : 'Pending';
  }
}
